<template>
  <div>
    <gmap-map
      :center="center"
      :zoom="16"
      style="width:100%;  height: 400px;"
      :draggable="true"
    >
      <gmap-marker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
      ></gmap-marker>
    </gmap-map>
  </div>
</template>

<script>
import * as VueGoogleMaps from 'vue2-google-maps';
import Vue from 'vue';

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyC27IQyViFB4ip6CAfIXeZbnyohxdeVEEc',
    libraries: 'places', // necessary for places input
  },
});

export default {
  name: 'GoogleMap',
  props: {
    lat: {
      type: String,
    },
    lng: {
      type: String,
    },
  },
  data() {
    return {
      // default to Montreal to keep it simple
      // change this to whatever makes sense
      center: { lat: 45.508, lng: -73.587 },
      markers: [],
    };
  },
  watch: {
    lat: {
      handler() {
        this.addMarker();
      },
    },
    lng: {
      handler() {
        this.addMarker();
      },
    },
  },

  mounted() {
    this.addMarker();
  },

  methods: {
    addMarker() {
      const marker = {
        lat: parseFloat(this.lat),
        lng: parseFloat(this.lng),
      };
      this.markers = [];
      this.markers.push({ position: marker });
      this.center = marker;
    },
  },
};
</script>
